import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import { clientShortName } from '@/helpers/clientShortName.js'
import vuecookie from 'vue-cookies'

const state = {
    welcomeMessage: ''
};

const getters = {
    getWelcomeMessage: (state) => state.welcomeMessage
};

const actions = {
    async updateWelcomeMessage( context, data ){
        return await axios.post(`${backendUrl()}/updateWelcomeMessage`, 
        {
            new_message: data.message,
            lang: data.lang
        },{
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response =>{
            if(response.data.status == 'success') {
                return response
            }
        })
    },

    async getWelcomeMessage ( context, data ) {
        return await axios.get(`${backendUrl()}/getWelcomeMessage/` + data, null,
        { headers: {
            'Authorization': "bearer " +  vuecookie.get('token')
        }}).then(response => {
            return response.data
        })
    }
};

const mutations = {
    setWelcomeMessage: (state, new_message) => (state.welcomeMessage = new_message)
};

export default {
  state,
  getters,
  actions,
  mutations
}


